import { render } from "./UrgentAlertModal.vue?vue&type=template&id=4a22aabb&scoped=true"
import script from "./UrgentAlertModal.vue?vue&type=script&lang=js"
export * from "./UrgentAlertModal.vue?vue&type=script&lang=js"

import "./UrgentAlertModal.vue?vue&type=style&index=0&id=4a22aabb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a22aabb"]])

export default __exports__